// extracted by mini-css-extract-plugin
export default {"faqPage":"FaqPagePVRCASELAW_faqPage__h1yXB","textArea":"FaqPagePVRCASELAW_textArea__rtFdd"};